import script from "./identity-informaiton.vue?vue&type=script&lang=ts&setup=true"
export * from "./identity-informaiton.vue?vue&type=script&lang=ts&setup=true"

import "./identity-informaiton.vue?vue&type=style&index=0&id=52c53c16&lang=scss&scoped=true"
import "./identity-informaiton.vue?vue&type=style&index=1&id=52c53c16&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c53c16"]])

export default __exports__